import React from 'react';

import Icon from 'components/DesignSystem/Icon';
import { cssVar } from 'constants/theme';

import './index.scss';

export interface ActionBarProps {
  selectionLabel: string;
  showRegenerate: boolean;
  onRegenerate: () => void;
  canGenerateMaps: boolean;
  isLoadingMaps: boolean;
  onGenerateMaps: () => void;
  canGenerateEnsemble: boolean;
  isGeneratingEnsemble: boolean;
  onGenerateEnsemble: () => void;
}

export default function ActionBar({
  selectionLabel,
  showRegenerate,
  onRegenerate,
  canGenerateMaps,
  isLoadingMaps,
  onGenerateMaps,
  canGenerateEnsemble,
  isGeneratingEnsemble,
  onGenerateEnsemble,
}: ActionBarProps) {
  const mapsEnabled = canGenerateMaps && !isLoadingMaps;
  const ensembleEnabled = canGenerateEnsemble && !isGeneratingEnsemble;

  return (
    <div className="agro-simil-action-bar">
      <div className="agro-simil-action-bar-top">
        <span className="agro-simil-action-bar-label">{selectionLabel}</span>
        {showRegenerate && (
          <button type="button" className="agro-simil-action-bar-regen" onClick={onRegenerate}>
            Atualizar mapas
          </button>
        )}
      </div>
      <div className="agro-simil-action-bar-buttons">
        <button
          type="button"
          className="agro-simil-action-bar-btn primary"
          disabled={!mapsEnabled}
          onClick={onGenerateMaps}
        >
          <Icon iconType="grid_view" size="small" color={cssVar(mapsEnabled ? 'text-on-accent' : 'text-disabled')} />
          {isLoadingMaps ? 'Gerando Mapas...' : 'Gerar Mapas'}
        </button>
        <button
          type="button"
          className="agro-simil-action-bar-btn secondary"
          disabled={!ensembleEnabled}
          onClick={onGenerateEnsemble}
        >
          <Icon iconType="layers" size="small" color={cssVar(ensembleEnabled ? 'text-accent' : 'text-disabled')} />
          {isGeneratingEnsemble ? 'Gerando Ensemble...' : 'Ensemble'}
        </button>
      </div>
    </div>
  );
}
